import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { Municipality, MunicipalitySearch } from '@ta-interaktiv/react-municipality-search'
import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'
const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  console.group('MUNISEARCH')
  console.log('props from disco:', properties)
  console.groupEnd()
  const defaultProperties = {
    // Default values used if they don't come from Unity
    bfsIdParamName: tenant?.lang === 'fr' ? 'commune' : 'gemeinde',
    label:
      tenant?.lang === 'fr' ? 'Commune sélectionnée:' : 'Ausgewählte Gemeinde:',
  }
  const propertiesWithDefaults = { ...defaultProperties, ...properties }

  const gdeProp = propertiesWithDefaults?.gdeProp || 'gemeinde'

  const municipalityDataYear =
    propertiesWithDefaults?.municipalityDataYear || '20220501'
  const eventID = propertiesWithDefaults?.eventID || 'changeGDE'
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const [currentMunicipality, setCurrentMunicipality] = useState<Municipality>()
  const updateBfsIdInURL = (bfsId: string) => {
    const url = new URL(String(window.location))
    console.log('bfsId:', bfsId)
    url.searchParams.set(propertiesWithDefaults.bfsIdParamName, bfsId)
    window.history.pushState({}, '', url)
  }
  useEffect(() => {
    // GET PARAMS FROM URL

    const searchParams = new URL(String(window.location)).searchParams
    const muniParam = searchParams.get(propertiesWithDefaults.bfsIdParamName!)
    const bfsIdFromUrl = muniParam && parseInt(muniParam)

    // IF NO GDE IS SELECTED AND GDNR IS PROVIDED FROM URL
    // FIND GDE IN GDE-FILE USED BY MUNICIPALITY SEARCH
    if (!currentMunicipality && bfsIdFromUrl) {
      findCurrentMunicipality(bfsIdFromUrl)
    }
  }, [])
  const findCurrentMunicipality = (bfsId: number, useLegacy?: boolean) => {
    const API_BASE_URL = useLegacy
      ? 'https://interaktiv.tagesanzeiger.ch/static/gemeindesuche/'
      : 'https://atm-municipality-search.s3.eu-west-1.amazonaws.com/'
    fetch(API_BASE_URL + `${municipalityDataYear}.json`)
      .then((a) => a.json())
      .then((a) => {
        let gde = a.find((f) => f.GDENR === bfsId)
        if (gde) setCurrentMunicipality(gde)
      })
      .catch((e) => {
        console.log('Error while fetching municipality data', e)
        if (!useLegacy) {
          // TRY ONCE WITH LEGACY URL
          findCurrentMunicipality(bfsId, true)
        }
      })
  }

  return (
    <AppContainer className={globalClasses.join(' ')} $colorMode={colorMode}>
      <TextWidth>
        <FlexContainer $colorMode={colorMode}>
          {currentMunicipality && (
            <CurrentMunicipalityDisplay $colorMode={colorMode}>
              <span>{propertiesWithDefaults.label}</span>
              {currentMunicipality.NORMGEMEINDE}
            </CurrentMunicipalityDisplay>
          )}
          <MunicipalitySearch
            onSelectionHandler={(muni: any) => {
              if (muni.GDENR) {
                updateBfsIdInURL(String(muni.GDENR))
              }
              if (eventID) {
                // SEND EVENT TO CHANGE BFS-NUMBER FOR ALL MICRO-FRONTENDS
                const newBfsIdEvent = new CustomEvent(eventID, {
                  detail: muni.GDENR,
                })
                console.log('...Dispatch GDE-Change')
                window.dispatchEvent(newBfsIdEvent)
              }
              if (muni) setCurrentMunicipality(muni)
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
              })
            }}
            municipalityData={municipalityDataYear}
            locale={tenant.lang}
            dedupe
            resetOnSelect
            showLastSelectedMunicipalities={true}
          ></MunicipalitySearch>
        </FlexContainer>
      </TextWidth>
    </AppContainer>
  )
}

const CurrentMunicipalityDisplay = styled.div<{
  $colorMode: 'light' | 'dark' | undefined
}>`
  flex: 0 0 50%;
  width: 100%;
  font-size: 18px;
  color: var(--text-color);
  text-align: left;
  line-height: 1em;
  padding-bottom: 0.5em;
  span {
    line-height: 1em;
    padding-bottom: 6px;
    display: inline-block;
    width: 100%;
    font-size: 12px;
    color: ${({ $colorMode: colorMode }) =>
      colorMode === 'dark' ? '#D4D4D4' : '#7d7d7d'};
  }
`
const FlexContainer = styled.div<{ $colorMode: 'light' | 'dark' }>`
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  border: ${({ $colorMode: colorMode }) =>
    colorMode === 'light'
      ? '1px solid var(--gray-5)'
      : '1px solid var(--gray-1)'};

  border-right: 0;
  border-left: 0;
  color: var(--text-color);
  // first child
`
const AppContainer = styled(TamediaStyles)<{
  tenant?: string
  $colorMode: 'light' | 'dark' | undefined
}>`
  width: 100%;

  padding: 0;
  font-family: var(--font-sans-serif);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 3rem;
  .results {
    position: static;
    background-color: ${({ $colorMode: colorMode }) =>
      colorMode === 'light' ? 'var(--gray-6)' : 'var(--gray-2)'};
  }
`
export default MainComponent
